/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {

  // Remove empty P tags created by WP inside of Accordion and Orbit
  jQuery('.accordion p:empty, .orbit p:empty').remove();

  // Adds Flex Video to YouTube and Vimeo Embeds
  jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
      jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
    } else {
      jQuery(this).wrap("<div class='responsive-embed'/>");
    }
  });
});

function debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this, args = arguments;
      var later = function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

/******
   * Mobile and Desktop  Menu Switch
   *
   * Desktop Menu: Second level menu dropdown
   * Mobile Menu: Second level menu slide to open
   ******/
 var menuState = "";
 var navigationBreakpoint = 1240;
 var mobileDesktopMenuSwitch = debounce(function() {
   if(menuState !== "mobile" && window.innerWidth < navigationBreakpoint) {
     menuState = "mobile";
     jQuery('.hamburger-icon').on('click', function(e){
       e.preventDefault();
       jQuery(this).toggleClass('active');
       jQuery(this).parents('.mobile-menu').toggleClass('first-level-open');
       jQuery('.mobile-menu').removeClass('second-level-open');
       jQuery('.menu-item-has-children').removeClass('open');
       jQuery('html').toggleClass('no-scroll');
     });
 
     jQuery('.menu-item-has-children > a').click(function(e){
       e.preventDefault();
       jQuery(this).parents('.mobile-menu').toggleClass('second-level-open');
       jQuery(this).parent().toggleClass('open');
     });
 
     jQuery('.menu-item-has-children > a').one('click', function(e){
       //This code onle need to run once
       jQuery(this).siblings('.second-level-menu').find('.second-level-parent').append(jQuery(this).clone());
     });
 
     jQuery('.mobile-menu .back-to-main').click(function(e) {
       jQuery('.mobile-menu').removeClass('second-level-open');
       jQuery('.menu-item-has-children').removeClass('open');
     });
   } else if(window.innerWidth >= navigationBreakpoint) {
     menuState = "desktop";
     jQuery('.hamburger-icon').off('click');
     jQuery('.menu-item-has-children > a').off('click');
     jQuery('.menu-item-has-children > a').off('click');
     jQuery('.second-level-menu .back').off('click');
   }
 }, 250);
 
 mobileDesktopMenuSwitch(); //run one on load
 window.addEventListener('resize', mobileDesktopMenuSwitch);